export enum FeatureFlagsEnum {
    FF_MrktplcBuyers_3_2 = 'FF_MrktplcBuyers_3_2',
    FF_MrktplcBuyers_3_3 = 'FF_MrktplcBuyers_3_3',
    FF_MrktplcSellers_2_3 = 'FF_MrktplcSellers_2_3',
    FF_MrktplcBuyers_3_4 = 'FF_MrktplcBuyers_3_4',
    FF_MrktplcSellers_2_4 = 'FF_MrktplcSellers_2_4',
    FF_Notifications = 'FF_Notifications',
    FF_MrktplcSellers_2_5 = 'FF_MrktplcSellers_2_5',
}
